import React    from 'react';

import * as images          from 'images/';
import MenuItem             from 'components/MenuItem';
import JustStandingOrders   from 'Passenger/components/StandingOrders';

export const StandingOrders : React.FC<{}> = props => {
    return (
        <MenuItem title={["Scheduled Orders ",<a key='download' href='/api/passenger/orders/scheduled?csv'><images.Download/></a>]}>
            <JustStandingOrders/>
        </MenuItem>
    );
}

export default StandingOrders;